import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom"; // ✅ ADD THIS
import { DetailedAnalyticsBrandPulseNew } from "../../common/analytics/detailed-analytics-new/src/index";
// import { BrandPulseProfileCard } from "./brand-pulse-profile-card"; // profile card no longer shown on shared links
import { AnalyticsService } from "../../../core/services/analytics.service";
import { BrandDataService } from "../../../core/services/brand-data.service";
import * as gtUtil from "../../../core/utility";

const brandDataService: BrandDataService = new BrandDataService();
const analyticsService = new AnalyticsService();

export const ShareBrandPulseCampaignList: React.FC<any> = () => {

  const [searchParams] = useSearchParams(); // ✅ ADD THIS

  const [isLoading, setIsLoading] = useState(true); // ✅ ADD THIS
  const [profileData, setProfileData] = useState(null);
  const [campaignId, setCampaignId] = useState<any>(null);
  const [brandRefId, setBrandRefId] = useState<any>(null);
  const [accessToken, setAccessToken] = useState<any>(null);
  // Shared link shows only the campaign name, not the brand profile card
  const [campaignTitle, setCampaignTitle] = useState<string>("");

  useEffect(() => {
    const token = searchParams.get("accessKey");

    if (token) {
      verifySharedToken(token);
    } else {
      console.error("No accessKey found in URL");
      setIsLoading(false); // ✅ IMPORTANT
    }
  }, []);

  // const handleBrandData = async (selectedRefId: any) => {
  //   try {
  //     const response = await brandDataService.profileCard(selectedRefId, accessToken);
  //     if (response.status == gtUtil.Constants.SUCCESS) {
  //       setProfileData(response.data.rows.brand_profile);
  //     }
  // accessToken state isn't set yet when this runs, so the token is passed in.
  // profileCard also returns the brand's campaigns (with titles) -- used for the heading.
  const handleBrandData = async (selectedRefId: any, sharedCampaignId: any, token: string) => {
    try {
      const response = await brandDataService.profileCard(selectedRefId, token);
      if (response.status == gtUtil.Constants.SUCCESS) {
        setProfileData(response.data.rows.brand_profile);
        const campaign = (response.data.rows.linked_campaign_id || []).find(
          (c: any) => Number(c.campaign_id) === Number(sharedCampaignId)
        );
        setCampaignTitle(campaign?.campaign_title || "");
      }
    } catch (error) {
      console.log(`Brand Pulse Api :: ${JSON.stringify(error)}`);
    }
  };

  const verifySharedToken = async (token: string) => {
    try {
      const res = await analyticsService.verifySharedUserBrandPulse({ token });

      if (res?.status === gtUtil.Constants.SUCCESS) {
        const { campaign_id, ref_id, username } = res.data;

        setBrandRefId(ref_id);
        setCampaignId(campaign_id);
        setAccessToken(token);
        // await handleBrandData(ref_id);
        await handleBrandData(ref_id, campaign_id, token);
      } else {
        console.error("Invalid or expired token");
      }
    } catch (error) {
      console.error("Token verification failed:", error);
    } finally {
      setIsLoading(false); // ✅ loader stops here
    }
  };

  // ✅ ✅ THIS IS WHERE YOU ADD LOADER
  if (isLoading) {
    return <div>Verifying access...</div>;
  }

  // ✅ MAIN UI
  return (
    <div className="mx-auto mt-2 position-relative">

      <div className="mt-5 mb-5 ">
        {/* <BrandPulseProfileCard loader={isLoading} profileData={profileData} /> */}
        {/* {campaignTitle && <h4 className="mb-0">{campaignTitle}</h4>} */}
        {campaignTitle && (
          <Box sx={{ textAlign: "center", px: 2 }}>
            <Box
              component="span"
              sx={{ fontSize: 13, letterSpacing: "0.08em", textTransform: "uppercase", color: "#64748b" }}
            >
              Campaign Performance
            </Box>
            <Box
              component="h2"
              sx={{ mt: 1, mb: 0, fontSize: { xs: 24, md: 32 }, fontWeight: 600, color: "#0f172a", lineHeight: 1.25 }}
            >
              {campaignTitle}
            </Box>
            <Box sx={{ width: 56, height: 3, borderRadius: 2, bgcolor: "#0f172a", mx: "auto", mt: 2 }} />
          </Box>
        )}
      </div>

      <Box mt={3}>
        {campaignId && (
          <DetailedAnalyticsBrandPulseNew
            key={campaignId}
            linkedCampaignId={campaignId}
            share_access_key={accessToken}
            campaignTitle={campaignTitle}
          />
        )}
      </Box>

    </div>
  );
};